<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Postulaciones</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Planta Externa</li>
                  <li class="breadcrumb-item active">Postulaciones</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <!-- Sección de filtros -->
            <div class="row">
              <div class="col-12">
                <div
                  class="card"
                  :class="
                    $store.getters.getDarkMode
                      ? 'bg-dark border-secondary'
                      : 'bg-white'
                  "
                >
                  <div
                    class="card-header py-2"
                    :class="
                      $store.getters.getDarkMode
                        ? 'bg-dark border-secondary'
                        : 'bg-light'
                    "
                  >
                    <h6
                      class="mb-0"
                      :class="
                        $store.getters.getDarkMode ? 'text-light' : 'text-dark'
                      "
                    >
                      <i class="fas fa-filter me-2"></i>
                      Filtros de Búsqueda
                    </h6>

                    <!-- <div class="float-right">
                      <button
                        type="button"
                        class="btn btn-outline-success"
                        data-toggle="modal"
                        data-target="#modal-form-postulacion-export"
                        data-bs-toggle="tooltip"
                        title="Exportar a Excel"
                      >
                        <i class="far fa-file-excel me-1"></i>
                        Exportar
                      </button>
                    </div> -->
                  </div>
                  <div class="card-body py-3">
                    <div class="row justify-content-center">
                      <!-- Filtro Empresa -->
                      <div class="col-md-4">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-building me-1"></i>
                          Empresa
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="empresa"
                          placeholder="Buscar empresa..."
                          label="razon_social"
                          class="form-control form-control-sm p-0"
                          :options="listasForms.empresas"
                          @search="buscarEmpresas"
                          @input="selectEmpresa()"
                        ></v-select>
                      </div>
                      <!-- Filtro Fecha -->
                      <div class="col-md-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-calendar me-1"></i>
                          Fecha
                        </label>
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          v-model="filtros.fecha"
                          @change="getIndex()"
                        />
                      </div>
                      <!-- Filtro Sitio -->
                      <div class="col-md-3">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-map-marker-alt me-1"></i>
                          Sitio Origen
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="sitio"
                          placeholder="Buscar sitio..."
                          label="nombre"
                          class="form-control form-control-sm p-0"
                          :options="listasForms.sitios"
                          @search="buscarSitios"
                          @input="selectSitio()"
                        ></v-select>
                      </div>
                      <!-- Filtro Sitio Destino -->
                      <div class="col-md-3">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-map-marker-alt me-1"></i>
                          Sitio Destino
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="destino"
                          placeholder="Buscar sitio..."
                          label="nombre"
                          class="form-control form-control-sm p-0"
                          :options="listasForms.sitios"
                          @search="buscarSitios"
                          @input="selectDestino()"
                        ></v-select>
                      </div>
                      <!-- Botón refrescar -->
                      <div class="col-md-2 pt-3">
                        <button
                          type="button"
                          class="btn btn-outline-primary btn-sm w-100"
                          @click="getIndex()"
                        >
                          <i class="fas fa-sync-alt fa-spin me-1"></i>
                          Refrescar
                        </button>
                      </div>
                      <!-- Botón limpiar filtros -->
                      <div class="col-md-2 pt-3">
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm w-100"
                          @click="limpiarFiltros()"
                        >
                          <i class="fas fa-eraser me-1"></i>
                          Limpiar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Contenido principal - Solo Tabla -->
            <div
              class="card"
              :class="
                $store.getters.getDarkMode
                  ? 'bg-dark border-secondary'
                  : 'bg-white'
              "
            >
              <div
                class="card-header py-2"
                :class="
                  $store.getters.getDarkMode
                    ? 'bg-dark border-secondary'
                    : 'bg-light'
                "
              >
                <div class="d-flex justify-content-between align-items-center">
                  <h6
                    class="mb-0"
                    :class="
                      $store.getters.getDarkMode ? 'text-light' : 'text-dark'
                    "
                  >
                    <i class="fas fa-table me-2"></i>
                    Lista de Programaciones
                  </h6>
                  <span class="badge bg-primary">
                    {{ detProgramaciones.total || 0 }} registros
                  </span>
                </div>
              </div>

              <div class="card-body p-0">
                <div class="table-responsive">
                  <table
                    class="table table-hover table-striped mb-0"
                    :class="$store.getters.getDarkMode ? 'table-dark' : ''"
                  >
                    <thead
                      :class="
                        $store.getters.getDarkMode
                          ? 'table-dark'
                          : 'table-light'
                      "
                    >
                      <tr>
                        <th class="text-center">
                          <i class="fas fa-hashtag"></i>
                        </th>
                        <th class="text-center">
                          <i class="fas fa-calendar-alt"></i> Programación
                        </th>
                        <th>
                          <i class="fas fa-building"></i>
                          Empresa
                        </th>
                        <th>
                          <i class="fas fa-calendar"></i>
                          Fecha
                        </th>
                        <th>
                          <i class="fas fa-map-marker-alt"></i>
                          Sitio Origen
                        </th>
                        <th>
                          <i class="fas fa-map-marker-alt"></i>
                          Sitio Destino
                        </th>
                        <th class="text-center">
                          <i class="fas fa-cogs"></i>
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(detProgramacion,
                        index) in detProgramaciones.data"
                        :key="index"
                      >
                        <td class="text-center">
                          <span class="badge bg-secondary">{{
                            detProgramacion.programacion.id
                          }}</span>
                        </td>
                        <td class="text-center">
                          {{ detProgramacion.programacion.nombre }}
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{
                              detProgramacion.empresa != null
                                ? detProgramacion.empresa.razon_social
                                : "No encontrada"
                            }}
                          </span>
                        </td>
                        <td>
                          {{ detProgramacion.programacion.fecha }}
                        </td>
                        <td v-if="detProgramacion.origen">
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ detProgramacion.origen.nombre }}
                          </span>
                        </td>
                        <td v-else>
                          <span class="badge bg-danger">Sin Asignar</span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{
                              detProgramacion.destino?.nombre ?? "Sin Asignar"
                            }}
                          </span>
                        </td>
                        <td class="text-center">
                          <div class="btn-group btn-group-sm" role="group">
                            <button
                              type="button"
                              :class="
                                new Date(
                                  detProgramacion.programacion.fecha + ' 00:00',
                                ) >= new Date()
                                  ? 'btn btn-outline-primary'
                                  : 'btn btn-outline-secondary'
                              "
                              @click="
                                edit(
                                  detProgramacion.empresa_id,
                                  detProgramacion.programacion.id,
                                )
                              "
                              :title="
                                new Date(detProgramacion.programacion.fecha) >=
                                new Date()
                                  ? 'Editar'
                                  : 'Ver'
                              "
                            >
                              <i
                                :class="
                                  new Date(
                                    detProgramacion.programacion.fecha,
                                  ) >= new Date('YYYY-MM-DD')
                                    ? 'fas fa-edit'
                                    : 'fas fa-eye'
                                "
                              ></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Mensaje cuando no hay datos -->
                <div
                  v-if="
                    !detProgramaciones.data ||
                      detProgramaciones.data.length === 0
                  "
                  class="text-center py-5"
                >
                  <h5 class="text-muted">No hay programaciones para mostrar</h5>

                  <div class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Cargando...</span>
                    </div>
                    <p class="mt-2 text-muted">Cargando Programaciones..</p>
                  </div>
                </div>
              </div>
              <div
                class="card-footer border-0"
                :class="
                  $store.getters.getDarkMode
                    ? 'bg-dark border-secondary'
                    : 'bg-light'
                "
              >
                <div class="d-flex justify-content-between align-items-center">
                  <div v-if="detProgramaciones.total">
                    <p class="mb-0 small text-muted">
                      Mostrando del
                      <span class="fw-bold text-primary">{{
                        detProgramaciones.from
                      }}</span>
                      al
                      <span class="fw-bold text-primary">{{
                        detProgramaciones.to
                      }}</span>
                      de un total:
                      <span class="fw-bold text-primary">{{
                        detProgramaciones.total
                      }}</span>
                      registros
                    </p>
                  </div>
                  <div v-else>
                    <span class="badge bg-danger">
                      No hay registros para mostrar
                    </span>
                  </div>
                  <pagination
                    :data="detProgramaciones"
                    @pagination-change-page="getIndex"
                    :limit="5"
                    align="right"
                  >
                  </pagination>
                </div>
              </div>
            </div>
          </div>
        </section>
        <PostulacionExport />
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import vSelect from "vue-select";
import pagination from "laravel-vue-pagination";
import PostulacionExport from "./PostulacionExport";
import Loading from "../../../../components/Loading";

export default {
  name: "PostulacionIndex",
  components: {
    pagination,
    vSelect,
    Loading,
    PostulacionExport,
  },
  data() {
    return {
      sitioOrigen: {},
      destino: {},
      empresa: {},
      cargando: false,
      detProgramaciones: {},
      filtros: {
        empresa_id: null,
        sitio_origen_id: null,
        sitio_destino_id: null,
        fecha: null,
        estado: null,
      },
      listasForms: {
        sitios: [],
        empresas: [],
        estados: [],
      },
    };
  },
  methods: {
    async getIndex(page = 1) {
      this.cargando = true;
      await axios
        .get("/api/plant/postulaciones?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.detProgramaciones = response.data;
          this.cargando = false;
        });
    },

    buscarSitios(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/plant/sitios/lista?nombre=" + search;
        axios
          .get(url)
          .then(function(response) {
            let respuesta = response.data;
            me.listasForms.sitios = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarEmpresas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/empresas/lista?razon=" + search;
        axios
          .get(url, {
            params: {
              linea_negocio_id: [17],
            },
          })
          .then(function(response) {
            let respuesta = response.data;
            me.listasForms.empresas = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    async getEstados() {
      await axios.get("/api/lista/36").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    selectDestino() {
      this.filtros.sitio_destino_id = null;
      if (this.destino) {
        this.filtros.sitio_destino_id = this.destino.id;
      }
      this.getIndex();
    },

    selectEmpresa() {
      this.filtros.empresa_id = null;
      if (this.empresa) {
        this.filtros.empresa_id = this.empresa.id;
      }
      this.getIndex();
    },

    selectSitioOrigen() {
      this.filtros.sitio_origen_id = null;
      if (this.sitioOrigen) {
        this.filtros.sitio_origen_id = this.sitioOrigen.id;
      }
      this.getIndex();
    },

    edit(empresa_id, programa_id) {
      return this.$router.push({
        name: "/plantaExterna/PostulacionForm",
        params: {
          empresa_id,
          programa_id,
        },
      });
    },

    limpiarFiltros() {
      this.filtros = {
        empresa_id: null,
        sitio_origen_id: null,
        sitio_destino_id: null,
        fecha: null,
        estado: null,
      };
      this.empresa = {};
      this.sitioOrigen = {};
      this.destino = {};
      this.detProgramaciones = {};
      this.getIndex();
    },
  },
  async mounted() {
    await this.getIndex();
    await this.getEstados();
  },
};
</script>
